// extracted by mini-css-extract-plugin
export default {"wrapper":"SideMenuComponent_wrapper__ZUIWx","hidden":"SideMenuComponent_hidden__itJMb","header":"SideMenuComponent_header__H3G6L"};